module.exports = __webpack_public_path__ + "static/media/ptiqcs-logo.4e1f3e6a.png";